import { ErrorMessagePage } from '@core/ui';
import { RouterType } from '@online-webinar/router';

export const updateRoute = (router: RouterType) => {
    router.routesById['/access-denied'].update({
        staticData: { title: { page: 'Generic.ApiErrorCode.AccessDeniedException' } },
        component: () => <ErrorMessagePage errorCode="401" />
    });
};
